import { IImageAsset } from '@aytm/app/swidget/base/modules/images/types'
import { IActionRulesSubLogicStatements } from '@aytm/app/swidget/base/actions/types'

export default function imageAssetWithOptions(rules: IActionRulesSubLogicStatements, image: IImageAsset): IImageAsset {
  if (!rules) return image
  const logicImage = Object.values(rules)
    .reverse()
    .find(v => v.condition && v.image)?.image

  return logicImage || image
}
